<div class="container-fluid tp-box vd-host" [@flipState]="flip">

	<!-- ═══════════════════════════════════ BACK (detail view) ═══════════════════════════════════ -->
	<div class="row tp-box__side tp-box__back" *ngIf="flip === 'active'">
		<div class="cw-wrap vd-wrap bpd-card w-100" [ngStyle]="themeVars">
			<div class="cw-icon-badge pointer" (click)="toggleFlip(false, '')" title="Back">
				<i class="material-icons">payments</i>
			</div>
			<div class="cw-header">
				<div class="cw-title-group">
					<span class="cw-title">Brand Payouts Pending
						<span class="bpd-title-badge" *ngIf="displayRows.length">{{ displayRows.length }}</span>
					</span>
				</div>
				<div class="vd-toolbar">
					<button class="btn btn-sm bpd-btn-xls" (click)="exportXls()" [disabled]="exporting || !displayRows.length" title="Export Excel">
						<i class="fa fa-file-excel-o"></i>
					</button>
					<button class="btn btn-sm bpd-btn-pdf" (click)="exportPdf()" [disabled]="exporting || !displayRows.length" title="Export PDF">
						<i class="fa fa-file-pdf-o"></i>
					</button>
				</div>
			</div>

			<div class="cw-body" *ngIf="viewing">

				<!-- ── Toolbar ── -->
				<div class="bpd-toolbar">
					<div class="bpd-toolbar__row">

						<mat-form-field appearance="outline" class="bpd-field bpd-field--search" subscriptSizing="dynamic">
							<mat-label>Search</mat-label>
							<input matInput [(ngModel)]="searchTerm" placeholder="Brand name or ID…" autocomplete="off">
							<mat-icon matSuffix>search</mat-icon>
						</mat-form-field>

						<mat-button-toggle-group [(ngModel)]="filterMode" class="bpd-filter-toggle" aria-label="Filter">
							<mat-button-toggle value="all">All</mat-button-toggle>
							<mat-button-toggle value="ready">
								<mat-icon class="bpd-toggle-icon">check_circle</mat-icon>
								Ready
							</mat-button-toggle>
						</mat-button-toggle-group>

						<div class="bpd-toolbar__end">
							<span class="bpd-count-pill">{{ displayRows.length }}&nbsp;brand{{ displayRows.length === 1 ? '' : 's' }}</span>
						</div>

					</div>
				</div>

				<!-- ── Table ── -->
				<div class="bpd-table-wrap" #print_table>
					<table class="table bpd-table">
						<thead class="thead-dark">
							<tr>
								<!-- hidden on xs -->
								<th class="bpd-th bpd-sortable bpd-col-id d-none d-sm-table-cell" (click)="sortBy('supplierid')">
									ID <mat-icon class="bpd-sort-icon">{{ getSortIcon('supplierid') }}</mat-icon>
								</th>
								<th class="bpd-th bpd-sortable" (click)="sortBy('suppname')">
									Vendor <mat-icon class="bpd-sort-icon">{{ getSortIcon('suppname') }}</mat-icon>
								</th>
								<!-- hidden on mobile -->
								<!-- Reference columns: open-AP basis, no collection weighting. Kept left of
								     the payout math, which is Available - Hold only. -->
								<th class="bpd-th bpd-th--info bpd-sortable text-right d-none d-lg-table-cell" (click)="sortBy('brand_ap_open')"
									matTooltip="Open AP on this brand, collected or not. Not part of the payout.">
									Open AP <mat-icon class="bpd-sort-icon">{{ getSortIcon('brand_ap_open') }}</mat-icon>
								</th>
								<th class="bpd-th bpd-th--info bpd-sortable text-right d-none d-lg-table-cell" (click)="sortBy('metrc_withhold')"
									matTooltip="Excise owed to NYS on open rows. Never the brand’s money — not deducted here.">
									Excise (NYS) <mat-icon class="bpd-sort-icon">{{ getSortIcon('metrc_withhold') }}</mat-icon>
								</th>
								<th class="bpd-th bpd-th--info bpd-sortable text-right d-none d-lg-table-cell" (click)="sortBy('fees_held')"
									matTooltip="MOOV’s cut, already netted out before the brand’s share. Not a further deduction.">
									Fees Earned <mat-icon class="bpd-sort-icon">{{ getSortIcon('fees_held') }}</mat-icon>
								</th>
								<!-- Payout math -->
								<th class="bpd-th bpd-sortable text-right d-none d-md-table-cell" (click)="sortBy('link_ready')"
									matTooltip="Brand’s share of cash actually collected, less payouts already sent.">
									Available <mat-icon class="bpd-sort-icon">{{ getSortIcon('link_ready') }}</mat-icon>
								</th>
								<th class="bpd-th bpd-sortable text-right d-none d-md-table-cell" (click)="sortBy('fronted_uncollected')"
									matTooltip="Excise + fees MOOV fronted on shipped-but-uncollected orders.">
									&minus;&nbsp;Hold <mat-icon class="bpd-sort-icon">{{ getSortIcon('fronted_uncollected') }}</mat-icon>
								</th>
								<th class="bpd-th bpd-sortable text-right bpd-col-payout" (click)="sortBy('net_payout_to_brand')">
									=&nbsp;Payout <mat-icon class="bpd-sort-icon">{{ getSortIcon('net_payout_to_brand') }}</mat-icon>
								</th>
								<th class="bpd-th bpd-col-actions"></th>
							</tr>
						</thead>

						<tbody>
							<ng-container *ngFor="let r of displayRows">

								<!-- Main row -->
								<tr class="bpd-row" [class.bpd-row--open]="expandedRow === r" (click)="toggleDetails(r)">
									<td class="bpd-cell bpd-cell--id d-none d-sm-table-cell">
										<span class="bpd-id-badge">{{ r.supplierid }}</span>
									</td>
									<td class="bpd-cell bpd-cell--name">
										<span class="bpd-brand-name">{{ r.suppname }}</span>
										<span class="bpd-brand-id-xs d-inline d-sm-none text-muted">&nbsp;#{{ r.supplierid }}</span>
									</td>
									<!-- Reference: open-AP basis, not payout arithmetic -->
									<td class="bpd-cell text-right bpd-num bpd-num--info d-none d-lg-table-cell">
										{{ toNum(r.brand_ap_open) | currency }}
									</td>
									<td class="bpd-cell text-right bpd-num bpd-num--info d-none d-lg-table-cell">
										<span *ngIf="toNum(r.metrc_withhold) > 0">{{ toNum(r.metrc_withhold) | currency }}</span>
										<span class="text-muted" *ngIf="toNum(r.metrc_withhold) <= 0">—</span>
									</td>
									<td class="bpd-cell text-right bpd-num bpd-num--info d-none d-lg-table-cell">
										<span *ngIf="toNum(r.fees_held) > 0">{{ toNum(r.fees_held) | currency }}</span>
										<span class="text-muted" *ngIf="toNum(r.fees_held) <= 0">—</span>
									</td>
									<!-- Payout math -->
									<td class="bpd-cell text-right bpd-num d-none d-md-table-cell">
										<span class="bpd-ready-chip" *ngIf="availableNet(r) > 0">
											{{ availableNet(r) | currency }}
										</span>
										<span class="bpd-num--warn" *ngIf="availableNet(r) < 0"
											matTooltip="Over-paid: payouts already sent exceed the brand's share of cash collected.">
											{{ availableNet(r) | currency }}
										</span>
										<span class="text-muted" *ngIf="availableNet(r) === 0">—</span>
									</td>
									<td class="bpd-cell text-right bpd-num bpd-num--warn d-none d-md-table-cell">
										<span *ngIf="toNum(r.fronted_uncollected) > 0">{{ toNum(r.fronted_uncollected) | currency }}</span>
										<span class="text-muted" *ngIf="toNum(r.fronted_uncollected) <= 0">—</span>
									</td>
									<td class="bpd-cell text-right bpd-col-payout">
										<span class="bpd-payout-amount"
											[class.bpd-payout-amount--zero]="toNum(r.net_payout_to_brand) === 0"
											[class.bpd-payout-amount--negative]="toNum(r.net_payout_to_brand) < 0">
											{{ toNum(r.net_payout_to_brand) | currency }}
										</span>
										<span class="bpd-owes-label" *ngIf="toNum(r.net_payout_to_brand) < 0">Negative Balance</span>
									</td>
									<td class="bpd-cell bpd-col-actions" (click)="$event.stopPropagation()">
										<button mat-icon-button class="bpd-action-btn bpd-action-btn--expand"
											[matTooltip]="expandedRow === r ? 'Collapse' : 'Details'"
											(click)="toggleDetails(r)">
											<mat-icon>{{ expandedRow === r ? 'expand_less' : 'expand_more' }}</mat-icon>
										</button>
										<button mat-icon-button class="bpd-action-btn bpd-action-btn--pay"
											matTooltip="Pay / Allocate"
											[disabled]="toNum(r.net_payout_to_brand) <= 0"
											(click)="openPaymentModal(r)">
											<mat-icon>payment</mat-icon>
										</button>
									</td>
								</tr>

								<!-- Detail panel row -->
								<tr *ngIf="expandedRow === r" class="bpd-detail-row">
									<td colspan="9" class="bpd-detail-cell">
										<div class="bpd-detail-panel">

											<div class="bpd-detail-panel__header">
												<mat-icon class="bpd-detail-panel__icon">storefront</mat-icon>
												<span class="bpd-detail-panel__name">{{ r.suppname }}</span>
												<span class="bpd-detail-panel__id">#{{ r.supplierid }}</span>
											</div>

											<div class="bpd-detail-panel__body">

												<div class="bpd-stat-grid">
													<!-- Payout math: only these two feed Final Payout -->
													<div class="bpd-stat">
														<span class="bpd-stat__label">Available</span>
														<span class="bpd-stat__value"
															[class.bpd-stat__value--positive]="availableNet(r) >= 0"
															[class.bpd-stat__value--warn]="availableNet(r) < 0">{{ availableNet(r) | currency }}</span>
													</div>
													<div class="bpd-stat">
														<span class="bpd-stat__label">Less Payout Hold</span>
														<span class="bpd-stat__value bpd-stat__value--warn">{{ toNum(r.fronted_uncollected) | currency }}</span>
													</div>
													<!-- Reference only: open-AP basis, no collection weighting. Tagged so they are
													     not read as further deductions - they are not. -->
													<div class="bpd-stat bpd-stat--info">
														<span class="bpd-stat__label">Open AP <span class="bpd-stat__tag">ref</span></span>
														<span class="bpd-stat__value">{{ toNum(r.brand_ap_open) | currency }}</span>
													</div>
													<div class="bpd-stat bpd-stat--info">
														<span class="bpd-stat__label">Excise &rarr; NYS <span class="bpd-stat__tag">ref</span></span>
														<span class="bpd-stat__value">{{ toNum(r.metrc_withhold) | currency }}</span>
													</div>
													<div class="bpd-stat bpd-stat--info">
														<span class="bpd-stat__label">Fees Earned <span class="bpd-stat__tag">ref</span></span>
														<span class="bpd-stat__value">{{ toNum(r.fees_held) | currency }}</span>
													</div>
												</div>

												<div class="bpd-payout-summary">
													<div class="bpd-payout-summary__label">{{ toNum(r.net_payout_to_brand) < 0 ? 'Negative Balance' : 'Final Payout' }}</div>
													<div class="bpd-payout-summary__amount"
														[class.bpd-payout-summary__amount--negative]="toNum(r.net_payout_to_brand) < 0">
														{{ toNum(r.net_payout_to_brand) | currency }}
													</div>
													<div class="bpd-payout-summary__math">
														{{ availableNet(r) | currency }} &minus; {{ toNum(r.fronted_uncollected) | currency }} hold
													</div>
													<button mat-flat-button color="accent" class="bpd-pay-btn" [disabled]="toNum(r.net_payout_to_brand) <= 0" (click)="openPaymentModal(r)">
														<mat-icon>payment</mat-icon>
														Pay / Allocate
													</button>
												</div>

											</div>

											<!-- Customer payment sources — why this brand is owed money -->
											<div class="bpd-invoice-detail">
												<div class="bpd-section-label">
													<div class="bpd-section-label__title">
														<mat-icon class="bpd-section-label__icon">account_balance_wallet</mat-icon>
														Customer Payment Sources
													</div>
													<button type="button"
														class="btn btn-sm bpd-include-settled"
														[class.active]="includeSettledPaymentLinks"
														(click)="toggleSettledPaymentLinks($event)">
														{{ includeSettledPaymentLinks ? 'Showing settled' : 'Include settled' }}
													</button>
												</div>
												<div *ngIf="paymentLinksLoading" class="text-center text-muted py-3">
													<svg class="spinner" width="24px" height="24px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
														<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
													</svg>
												</div>
												<ng-container *ngIf="!paymentLinksLoading">
													<div *ngIf="!paymentLinks.length" class="text-muted small py-2 px-3">
														{{ includeSettledPaymentLinks ? 'No customer payment records found.' : 'No open customer payment records found.' }}
													</div>
													<div class="table-responsive" *ngIf="paymentLinks.length">
														<table class="table table-sm bpd-inv-table mb-0">
															<thead>
																<tr>
																	<th>Brand</th>
																	<th>Customer</th>
																	<th>Inv #</th>
																	<th>Inv Date</th>
																	<th>Order Ref</th>
																	<th class="text-right">Customer Inv</th>
																	<th class="text-right">Brand Portion</th>
																	<th class="text-right">Excise</th>
																	<th class="text-right">Fees</th>
																	<th class="text-center">Customer Paid</th>
																	<th>Payment Ref</th>
																	<th class="text-center">AP Settled</th>
																</tr>
															</thead>
															<tbody>
																<tr *ngFor="let lnk of paymentLinks"
																	[class.table-success]="isCustomerPaid(lnk)"
																	[class.table-warning]="!isCustomerPaid(lnk)">
																	<td class="bpd-brand-name">{{ lnk.brand_name || expandedRow?.suppname }} · #{{ lnk.brand_supplierno || expandedRow?.supplierid }}</td>
																	<td class="bpd-brand-name">{{ lnk.customer_name || lnk.debtorno || '—' }}</td>
																	<td class="text-muted small">{{ lnk.inv_transno || '—' }}</td>
																	<td class="text-muted small">{{ lnk.inv_trandate || '—' }}</td>
																	<td class="text-muted small">{{ lnk.inv_reference || '—' }}</td>
																	<td class="text-right">{{ lnk.inv_amount | number:'1.2-2' }}</td>
																	<td class="text-right bpd-num">{{ lnk.brand_amount | number:'1.2-2' }}</td>
																	<td class="text-right text-muted">{{ lnk.excise_held > 0.005 ? (lnk.excise_held | number:'1.2-2') : '—' }}</td>
																	<td class="text-right text-muted">{{ lnk.fees_held > 0.005 ? (lnk.fees_held | number:'1.2-2') : '—' }}</td>
																	<td class="text-center">
																		<span *ngIf="isCustomerPaid(lnk)" class="bpd-paid-chip bpd-paid-chip--yes" [title]="customerPaidTitle(lnk)">
																			<mat-icon class="bpd-chip-icon">check_circle</mat-icon>
																			{{ customerPaidLabel(lnk) }}
																		</span>
																		<span *ngIf="!isCustomerPaid(lnk)" class="bpd-paid-chip bpd-paid-chip--pending">
																			<mat-icon class="bpd-chip-icon">hourglass_empty</mat-icon>
																			Pending
																		</span>
																	</td>
																	<td class="text-muted small">
																		<ng-container *ngIf="lnk.pay_transno">
																			<span>#{{ lnk.pay_transno }}</span>
																			<span *ngIf="lnk.pay_trandate"> · {{ lnk.pay_trandate }}</span>
																			<span *ngIf="lnk.pay_reference" class="d-block text-truncate" style="max-width:160px" [title]="lnk.pay_reference">{{ lnk.pay_reference }}</span>
																		</ng-container>
																		<span *ngIf="!lnk.pay_transno" class="text-muted">—</span>
																	</td>
																	<td class="text-center" [class.text-success]="lnk.brand_ap_settled == '1'" [class.text-muted]="lnk.brand_ap_settled != '1'">
																		{{ lnk.brand_ap_settled == '1' ? 'Settled' : 'Open' }}
																	</td>
																</tr>
															</tbody>
														</table>
													</div>
												</ng-container>
											</div>

											<!-- Open AP invoices -->
											<div class="bpd-invoice-detail bpd-invoice-detail--ap">
												<div class="bpd-section-label">
													<mat-icon class="bpd-section-label__icon">receipt_long</mat-icon>
													Open AP Invoices
												</div>
												<div *ngIf="detailLoading" class="text-center text-muted py-3">
													<svg class="spinner" width="24px" height="24px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
														<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
													</svg>
												</div>
												<ng-container *ngIf="!detailLoading">
													<div *ngIf="!detailRows.length" class="text-muted small py-2 px-3">No invoice transactions found.</div>
													<div class="table-responsive" *ngIf="detailRows.length">
														<table class="table table-sm bpd-inv-table mb-0">
															<thead>
																<tr>
																	<th>Brand</th>
																	<th>Doc #</th>
																	<th>Date</th>
																	<th>Reference</th>
																	<th>Dispensary</th>
																	<th class="text-right">Gross</th>
																	<th class="text-right">Excise 9%</th>
																	<th class="text-right">Dist 10%</th>
																	<th class="text-right">Fee</th>
																	<th class="text-right">Net</th>
																	<th class="text-center">Settled</th>
																</tr>
															</thead>
															<tbody>
																<tr *ngFor="let inv of detailRows">
																	<td class="bpd-brand-name">{{ inv.suppname || expandedRow?.suppname }} · #{{ inv.supplierno || expandedRow?.supplierid }}</td>
																	<td>{{ inv.transno }}</td>
																	<td>{{ inv.trandate }}</td>
																	<td>{{ inv.suppreference || '—' }}</td>
																	<td class="text-muted small">{{ inv.pp_dispensary_name || '—' }}</td>
																	<td class="text-right">{{ isFeeBearing(inv) ? (inv.pp_order_total | number:'1.2-2') : '—' }}</td>
																	<td class="text-right">{{ isFeeBearing(inv) ? (inv.pp_excise_tax | number:'1.2-2') : '—' }}</td>
																	<td class="text-right">{{ isFeeBearing(inv) ? (inv.pp_distribution_fee | number:'1.2-2') : '—' }}</td>
																	<td class="text-right">{{ isFeeBearing(inv) ? (inv.pp_metrc_fee | number:'1.2-2') : '—' }}</td>
																	<td class="text-right">{{ inv.totalamount | number:'1.2-2' }}</td>
																	<td class="text-center" [class.text-success]="inv.settled == '1'" [class.text-danger]="inv.settled != '1'">
																		{{ inv.settled == '1' ? 'Paid' : 'Open' }}
																	</td>
																</tr>
															</tbody>
														</table>
													</div>
												</ng-container>
											</div>
										</div>
									</td>
								</tr>

							</ng-container>

							<!-- Empty state -->
							<tr *ngIf="!displayRows.length" class="bpd-empty-row">
								<td colspan="9">
									<div class="bpd-empty">
										<mat-icon class="bpd-empty__icon">search_off</mat-icon>
										<span>No brands match your search or filter</span>
									</div>
								</td>
							</tr>
						</tbody>

						<!-- Footer totals -->
						<tfoot *ngIf="displayRows.length">
							<!-- Net position: every cell here is the straight sum of the column above
							     it, and Available − Hold = Payout across the row, so the footer ties to
							     what is on screen. Reference columns stay un-totalled: their bases differ
							     from the payout math, so a sum there would not tie to anything. -->
							<tr class="bpd-footer-row">
								<td class="d-none d-sm-table-cell"></td>
								<td class="bpd-footer-label">
									Net position — {{ displayRows.length }} brand{{ displayRows.length === 1 ? '' : 's' }}
								</td>
								<td class="d-none d-lg-table-cell"></td>
								<td class="d-none d-lg-table-cell"></td>
								<td class="d-none d-lg-table-cell"></td>
								<td class="text-right bpd-footer-total d-none d-md-table-cell"
									[class.bpd-footer-total--negative]="displayAvailableTotal < 0">{{ displayAvailableTotal | currency }}</td>
								<td class="text-right bpd-footer-total d-none d-md-table-cell">{{ displayHoldTotal | currency }}</td>
								<td class="text-right bpd-footer-total"
									[class.bpd-footer-total--negative]="displayTotal < 0">{{ displayTotal | currency }}</td>
								<td></td>
							</tr>
							<!-- Payable = positive balances only. This is the figure on the card face;
							     it is deliberately NOT the column sum, so it gets its own labelled row
							     instead of sitting under the Payout column pretending to be one. -->
							<tr class="bpd-footer-row bpd-footer-row--payable">
								<td class="d-none d-sm-table-cell"></td>
								<td class="bpd-footer-label">
									Payable now — {{ payableCount }} brand{{ payableCount === 1 ? '' : 's' }} owed
								</td>
								<td class="d-none d-lg-table-cell"></td>
								<td class="d-none d-lg-table-cell"></td>
								<td class="d-none d-lg-table-cell"></td>
								<td class="d-none d-md-table-cell"></td>
								<td class="d-none d-md-table-cell"></td>
								<td class="text-right bpd-footer-total">{{ displayPayableTotal | currency }}</td>
								<td></td>
							</tr>
						</tfoot>
					</table>
				</div>

			</div>
		</div>
	</div>

	<!-- ═══════════════════════════════════ FRONT (stat card) ═══════════════════════════════════ -->
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip === 'inactive' ? '' : 'd-none'">
		<div class="col-12 p-0">
			<app-dashboard-stat-card
				title="Brand Payouts Pending"
				icon="payments"
				accent="success"
				[value]="cardTotalDisplay"
				[loading]="!rowsLoaded"
				[showView]="rowsLoaded"
				(view)="toggleFlip(rows, 'All')">
			</app-dashboard-stat-card>
		</div>
	</div>

</div>
